import { render, staticRenderFns } from "./notascert.vue?vue&type=template&id=38cd2790"
import script from "./notascert.vue?vue&type=script&lang=js"
export * from "./notascert.vue?vue&type=script&lang=js"
import style0 from "./notascert.vue?vue&type=style&index=0&id=38cd2790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports